<!--日历组件-->
<template>
    <div style="position:relative">
        <el-calendar v-model="calendarValue" id="calendar">
            <div slot="dateCell" slot-scope="{date, data}" @click.stop="clickTime(date, data)">
                <!--自定义内容-->
                <div style="position: relative;height: 100%;">
                    <div class="calendar-day">{{ data.day.split('-').slice(2).join('-') }}</div>
                    <div v-for="(item,key) in calendarData" :key="key" style="position: absolute;top: -5px;width: 100%;">
                        <div v-if="formatTime(item.createTime,'year',data.day).indexOf(data.day.split('-').slice(0,1))!=-1">
                            <div v-if="formatTime(item.createTime,'month').indexOf(data.day.split('-').slice(1,2))!=-1">
                                <div v-if="formatTime(item.createTime,'day').indexOf(data.day.split('-').slice(2))!=-1">
                                    <div style="width: 100%; position: absolute;top: 8px;display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;align-items: baseline;">
                                        <div :style="'width:6px;height:6px;backgroundColor:'+ getColor(childItem)" v-for="(childItem,keys) in item.taskLevel" :key="keys"></div>
                                        <!-- :style="[{width: calculationNum+'%'}, {backgroundColor: getColor()}]" -->
                                        <!-- <span :style="'color:'+ getColor()">+{{calculationNum}}%</span> -->
                                    </div>
                                </div>
                                <!-- <div v-else></div> -->
                            </div>
                            <!-- <div v-else></div> -->
                        </div>
                        <!-- <div v-else></div> -->
                    </div>
                </div>
            </div>
        </el-calendar>

        <div class="calendarFooter">
            <span class="footerBox" style="backgroundColor:#00BFDD;"></span> 一级事项&nbsp;&nbsp;
            <span class="footerBox" style="backgroundColor:#7874CE"></span> 二级事项&nbsp;&nbsp;
            <span class="footerBox" style="backgroundColor:#FFAB00"></span> 三级事项&nbsp;&nbsp;
            <span class="footerBox" style="backgroundColor:#E64C66"></span> 四级事项&nbsp;&nbsp;
        </div>

        <div v-if="taskPanelVisible">
            <TaskPanel :taskObj="taskObj" @taskPanelClose="taskPanelClose" @getTaskParam="paramToWeb"></TaskPanel>
        </div>
    </div>
</template>

<script>
    import TaskPanel from './TaskPanel.vue' //任务面板
    export default {
        name:'webIndexCalendar',
        components:{
            TaskPanel
        },
        props:{

        },
        data(){
            return {
                //日历数据
                calendarData: [],
                calendarValue: new Date(), //当前日期
                dateTime: new Date().getTime(), //当前时间戳
                taskPanelVisible: false,
                taskObj: {}, //传递任务面板对象
                colorList:['#00BFDD','#7874CE','#FFAB00','#E64C66'],    //一级，二级，三级，四级
                getDataFlag: false,
            }
        },
        watch:{
            calendarValue(newValue){
                this.dateTime = newValue.getTime()
                if(!this.getDataFlag){
                    this.getQueryTaskData()
                }
            }
        },
        methods:{
            //跳转
            paramToWeb(e){
                this.$emit('getTaskParam',e)
                this.taskPanelVisible = false
            },
            //日历点击
            clickTime(date, data) {
                this.taskObj.dayTime = date.getTime()
                this.taskObj.type = 'calendar'
                this.taskPanelVisible = true
                console.log('日历点', date.getTime(), data);
            },
            //任务面板
            taskPanelClose(data) {
                console.log('任务面板',data);
                this.taskPanelVisible = data
                !this.taskPanelVisible && this.getQueryTaskData()
            },
            //查询本月任务信息
            getQueryTaskData() {
                this.getDataFlag = true
                this.$http.getQueryTaskData({
                    "queryDate": this.dateTime
                }).then((res) => {
                    if (res && res.status == 200 && res.result.length>0) {
                        let resArr = res.result
                        this.calendarData = []
                        this.calendarData.push(JSON.parse(JSON.stringify(resArr[0])))
                        this.calendarData[0].taskLevel = []
                        this.calendarData[0].taskLevel.push(resArr[0].taskLevel)

                        // let newArr = [{date:2021-01-01,dj:[1,2,3,4]},{}]
                        resArr.forEach((item,k) => {
                            let flag = false
                            for (let i = 0; i < this.calendarData.length; i++) {
                                let v = this.calendarData[i];
                                if(item.createTime === v.createTime){
                                    flag = true
                                    if(v.taskLevel.indexOf(item.taskLevel) === -1){
                                        v.taskLevel.push(item.taskLevel)
                                    }
                                }
                            }
                            if(!flag){
                                let obj = JSON.parse(JSON.stringify(item))
                                obj.taskLevel = []
                                obj.taskLevel.push(item.taskLevel)
                                this.calendarData.push(obj)
                            }
                        })
                        this.getDataFlag = false
                        // console.log('ga',this.calendarData);
                    } else if(res && res.status == 200 && res.result.length==0) {
                        this.getDataFlag = false
                    }else{
                        this.getDataFlag = false
                        this.$message({
                            message: res.message,
                            type: "error",
                        })
                    }
                }).catch((rej) => {
                    this.getDataFlag = false
                    this.$message({
                        message: rej.message,
                        type: "error",
                    })
                })
            },
            
            //获取颜色
            getColor(str){
                str = str.toString()
                if(str == 1 || str == '一' ||str.indexOf('1')>0 || str.indexOf('一')>0){
                    return this.colorList[0]
                }else if(str == 2 || str == '二' ||str.indexOf('2')>0 || str.indexOf('二')>0){
                    return this.colorList[1]
                }else if(str == 3 || str == '三' ||str.indexOf('3')>0 || str.indexOf('三')>0){
                    return this.colorList[2]
                }else{
                    return this.colorList[3]
                }
            },
            //时间获取
            formatTime(time, type,daya) {
                // console.log(daya);
                var date = new Date(time); // 初始化日期
                if (type) {
                    if (type == 'year') {
                        return String(date.getFullYear()); //获取年份
                    } else if (type == 'month') {
                        let num = Number(date.getMonth()) + 1
                        num = num>=10? num:'0'+num
                        // console.log('month',num);
                        return String(num); // 获取月份
                    } else if (type == 'day') {
                        let num = Number(date.getDate())
                        num = num>=10? num:'0'+num
                        // console.log('day',num);
                        return String(num); // 获取具体日
                    }
                }else{
                    return date.getFullYear()+'-'+(Number(date.getMonth()) + 1)+'-'+date.getDate()
                }
                // var hour = date.getHours(); // 获取时
                // var minutes = date.getMinutes(); // 获取分
                // var seconds = date.getSeconds(); // 获取秒
            },
        },
        created(){
            this.getQueryTaskData()
        }
    }
</script>

<style scoped>
.el-calendar{
    height: 392px;
    border-radius: 10px;
    background-color: #fff;
}

::v-deep .el-calendar-table .el-calendar-day {
    height: 40px;
    line-height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
}
::v-deep .el-calendar-table .el-calendar-day>div{
    width: 100%;
    height: 100%;
    text-align: center;
}
.calendar-day{
    height: 100%;
}
.is-selected {
    font-size: 5px;
}
/* ::v-deep .el-calendar-table:not(.is-range) td.next,::v-deep .el-calendar-table:not(.is-range) td.prev{
    color: #FFFFFF;
} */
.calendarFooter{
    font-size: 12px;
    color:#333;
    position: absolute;
    bottom: 10px;
    left: 20px;
}
.calendarFooter .footerBox{
    display:inline-block;
    width:10px;
    height:10px;
}
/* 禁用el-calendar灰色日期点击事件 */
#calendar ::v-deep .el-calendar-table:not(.is-range) td.next, #calendar ::v-deep .el-calendar-table:not(.is-range) td.prev{
    pointer-events: none;
}
</style>